import * as React from 'react';
import { FC, Suspense } from 'react';

import { use$, useEffectOnce } from '@legendapp/state/react';

import { useMediaData } from './hooks/use-media-data';

import App from './components/app/App';
import EditorMode from './components/editor-mode';
import { rootStore } from './store';
import { nbaStore } from './store/stores/nba-store';

interface AppProps {
	readonly isEditorMode: boolean;
}

type Props = AppProps;

const AppComponent: FC<Props> = ({ isEditorMode }) => {
	useMediaData();

	const isBffLoaded = use$(rootStore.isLoaded.bff);
	const assets = use$(rootStore.bffData.assets);
	const hasAssets = Object.keys(assets ?? {}).length > 0;

	// Set NBAB here - why? render of CMS loading spinner :(
	useEffectOnce(() => {
		nbaStore.subscribeToAllNBATransfers();
		return () => nbaStore.unsubscribeToAllNBATransfers();
	}, []);

	if (isEditorMode) {
		return <EditorMode />;
	}

	if (isBffLoaded && !hasAssets) {
		return null;
	}

	return (
		<Suspense fallback={<></>}>
			<App />
		</Suspense>
	);
};

export default AppComponent;
